// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605210424/js/" + chunkId + "." + {"44":"71035180","225":"58884c71","481":"ae1dcfeb","486":"d3fe26de","770":"7af71584"}[chunkId] + ".0.40443527800164225.chunk.js";
};